import { Calendar } from 'lucide-react';
import { BOOK_REPLY } from './constants';

export const ChatQuickReplies = ({ replies, onSelect }) => {
  if (!replies.length) return null;
  return (
    <div className="px-4 pb-2 bg-[#0C0C0C] md:bg-transparent">
      <div className="flex flex-wrap gap-2">
        {replies.map((reply, index) => (
          <button
            key={`reply-${reply.replace(/\s+/g, '-').toLowerCase()}`}
            onClick={() => onSelect(reply)}
            className={`px-3 py-2 text-xs border rounded-full transition-colors inline-flex items-center gap-1.5 ${
              reply === BOOK_REPLY
                ? 'bg-[#007AFF] border-[#007AFF] text-white hover:bg-[#3395FF] font-semibold'
                : 'bg-[#1a1a1a] border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF] hover:text-white'
            }`}
            data-testid={`quick-reply-${index}`}
          >
            {reply === BOOK_REPLY && <Calendar className="w-3.5 h-3.5" />}
            {reply}
          </button>
        ))}
      </div>
    </div>
  );
};
